import { render, staticRenderFns } from "./JustificationDetail.vue?vue&type=template&id=7256f877"
import script from "./JustificationDetail.vue?vue&type=script&lang=js"
export * from "./JustificationDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports